import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.article `
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  height: 100%;

  @media ${until(Device.Tablet)} {
    &[data-center-m='true'] {
      align-items: center;
      text-align: center;
    }
  }
`;
const Icon = styled.img `
  display: block;
  height: 68px;
  margin: 0 0 24px;
  object-fit: contain;
  object-position: center left;
  /* width: 68px; */

  @media ${until(Device.Tablet)} {
    height: 50px;
    margin: 0 0 16px;
    /* width: 50px; */
  }
`;
const Title = styled.h3 `
  ${fonts.sourceSansPro.semiBold};
  font-size: 24px;
  line-height: 34px;
  margin: 0 0 8px;
  color: ${cssVar('fgColor')};

  @media ${until(Device.Tablet)} {
    font-size: 18px;
    line-height: 24px;
  }
`;
const Content = styled.p `
  ${fonts.sourceSansPro.regular};
  font-size: 22px;
  line-height: 34px;
  margin: 0 0 24px;
  color: ${cssVar('fgColor')};

  @media ${until(Device.Tablet)} {
    font-size: 16px;
    line-height: 26px;
  }
`;
const Link = styled.a `
  display: inline-flex;
  align-items: center;
  color: ${cssVar('accentColorAlt')};
  ${fonts.sourceSansPro.semiBold};
  font-size: 18px;
  line-height: 22px;
  margin: auto 0 0 0;
  text-decoration: none;
  text-underline-position: under;

  > svg {
    display: inline-block;
    height: 12px;
    margin-left: 8px;
    transform: translateY(1px);
    transition: transform 0.15s ease-out;
    width: 12px;
  }

  @media ${until(Device.Tablet)} {
    font-size: 16px;
    line-height: 22px;

    > svg {
      display: inline-block;
      height: 10px;
      margin-left: 4px;
      transform: translateY(1px);
      width: 10px;
    }
  }

  &:focus,
  &:hover {
    text-decoration: underline;

    > svg {
      transform: translateY(1px) translateX(8px);
    }
  }
`;
export default {
    Container,
    Content,
    Icon,
    Link,
    Title,
};
